import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import GroupCard from "@/components/cards/GroupCard.tsx";
import KidsGroupCard from "@/components/cards/KidsGroupCard";
import Input from "@/components/inputs/Input.tsx";

import { ROUTES } from "@/config/routes.ts";
import { useGetCollections } from "@/hooks/api/content.hooks.ts";
import { useIsKids } from "@/hooks/useIsKids";

const CollectionsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: collections } = useGetCollections();
  const isKids = useIsKids();

  const [filterValue, setFilterValue] = useState("");

  return (
    <section className={"rounded-7.5 py-10 max-lg:rounded-5 max-lg:py-6"}>
      <div
        className={"flex items-center justify-between max-md:w-full max-md:flex-col max-md:items-stretch max-md:gap-6"}
      >
        <h1 className={"text-4xl font-semibold max-md:text-3xl/10"}>{t("General.collection", { count: 5 })}</h1>
        <Input
          type={"search"}
          color={"white"}
          placeholder={t("Actions.search-key-words")}
          onChange={(e) => setFilterValue(e.target.value)}
          value={filterValue}
          className={"w-[20.3125rem] py-3.5 max-md:w-full"}
        />
      </div>
      <div className={"movies-grid mt-8"}>
        {collections
          .filter((collection) => collection.title.toLowerCase().includes(filterValue.toLowerCase()))
          .map((collection) =>
            collection.is_kids || isKids ? (
              <KidsGroupCard
                title={collection.title}
                link={ROUTES.MAIN.COLLECTION.replace(":id", collection.id.toString())}
                imageSrc={collection.picture.small}
              />
            ) : (
              <GroupCard
                title={collection.title}
                link={ROUTES.MAIN.COLLECTION.replace(":id", collection.id.toString())}
                imageSrc={collection.picture.small}
              />
            ),
          )}
      </div>
    </section>
  );
};

export default CollectionsPage;
